export { default } from "./AgentConfigurationLink";
